import { Button, Col, Container, Form, Row } from "react-bootstrap"

const ServiceForm = () => {
    return (
        <Container className="service-request">
            <Row className="g-0 service-form justify-content-between">
                <Col md="12">
                    <h2>Get In Touch</h2>
                </Col>
                <Col md="6" className="mb-3 form-field">
                    <Form.Control type="text" placeholder="Name" />
                </Col>
                <Col md="6" className="mb-3 form-field">
                    <Form.Control type="text" placeholder="Email" />
                </Col>
                <Col md="6" className="mb-3 form-field">
                    <Form.Control type="text" placeholder="Phone Number" />
                </Col>
                <Col md="6" className="mb-3 form-field">
                    <Form.Control type="text" placeholder="Subject" />
                </Col>
                <Col md="12">
                    <Form.Control as="textarea" placeholder="Subject" className="message" />
                </Col>
                <Button variant="primary" type="submit" className="default-btn-style">Submit</Button>
            </Row>
        </Container>
    );   
}

export default ServiceForm;